/** Footer link configuration for the public footer. Add new use cases/columns here. */

interface FooterLink {
	label: string;
	to: string;
}

export interface FooterColumn {
	heading: string;
	headingTo?: string;
	links: FooterLink[];
}

export const FOOTER_COLUMNS: FooterColumn[] = [
	{
		heading: "AI Teammates",
		headingTo: "/ai-teammates",
		links: [
			{ label: "Marketing", to: "/ai-teammates/marketing" },
			{ label: "SEO", to: "/ai-teammates/marketing/seo" },
			{ label: "Google Ads", to: "/ai-teammates/marketing/google-ads" },
		],
	},
	{
		heading: "Product",
		headingTo: "/",
		links: [
			{ label: "Pricing", to: "/pricing" },
			{ label: "Sign up", to: "/signup" },
			{ label: "Log in", to: "/login" },
		],
	},
	{
		heading: "Developers",
		headingTo: "/developers",
		links: [
			{ label: "Documentation", to: "/docs" },
			{ label: "API Reference", to: "/docs/api-reference" },
			{ label: "SDK Quick Start", to: "/docs/quickstart" },
			{ label: "CLI", to: "/docs/cli" },
		],
	},
	{
		heading: "Legal",
		links: [
			{ label: "Privacy Policy", to: "/privacy-policy" },
			{ label: "Terms", to: "/terms" },
		],
	},
];

export const SOCIAL_LINKS = [
	{ href: "https://github.com/m8tes-ai", label: "GitHub", icon: "github" as const },
	{ href: "https://twitter.com/m8tes_ai", label: "X (Twitter)", icon: "twitter" as const },
];
